import React from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";

export const BusinessTaxCard = ({ s, setS }) => (
  <div className="border border-border rounded-sm p-6 bg-card space-y-4 max-w-xl mt-6" data-testid="business-tax-card">
    <div>
      <div className="font-medium">Business &amp; tax invoices</div>
      <p className="text-xs text-muted-foreground italic mt-1">Shown on every receipt email so Australian buyers get a proper invoice.</p>
    </div>
    <div><Label>Business name on invoices</Label><Input value={s.business_name || ""} onChange={(e) => setS({ ...s, business_name: e.target.value })} className="rounded-sm mt-1.5" data-testid="set-business-name" /></div>
    <div><Label>ABN</Label><Input value={s.abn || ""} onChange={(e) => setS({ ...s, abn: e.target.value })} placeholder="12 345 678 901" className="rounded-sm mt-1.5 font-mono" data-testid="set-abn" /></div>
    <div className="flex items-start justify-between gap-4">
      <div>
        <Label>Registered for GST</Label>
        <p className="text-xs text-muted-foreground italic mt-1">
          {s.gst_registered ? "Receipts say “Tax invoice” and show the GST (1/11th) included in the price." : "Receipts say “Invoice” and “No GST has been charged”."}
        </p>
      </div>
      <Switch checked={!!s.gst_registered} onCheckedChange={(v) => setS({ ...s, gst_registered: v })} data-testid="set-gst" />
    </div>
  </div>
);
